import {
	CREATE_CHECKOUT,
	CHECKOUT_CREATED,
	CHECKOUT_CREATE_FAILED
} from "../../shared/constants";

const initCheckoutData = {
	searchId: null,
	legacyId: null,
	outboundId: null,
	inboundId: null,
	creatingCheckout: false,
	checkoutId: null,
	fullCheckout: null,
	recalculating: false,
	errorGet: null
};

export const createCheckout = (state = initCheckoutData, action) => {
	switch (action.type) {
		case CREATE_CHECKOUT:
			if (action.checkoutData) {
				return {
					...state,
					searchId: action.checkoutData.searchId,
					legacyId: action.checkoutData.legacyId,
					outboundId: action.checkoutData.outboundId,
					inboundId: action.checkoutData.inboundId,
					creatingCheckout: true
				};
			}

		case CHECKOUT_CREATE_FAILED:
			if (action.checkoutId) {
				return {
					...state,
					creatingCheckout: false,
					creatingCheckoutError: action.error
				};
			}

		case CHECKOUT_CREATED:
			if (action.checkoutId) {
				return {
					...state,
					creatingCheckout: false,
					checkoutId: action.checkoutId
				};
			}

		default:
			return state;
	}
};
